var _path, _path2, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCallSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9961 12.22C20.9961 6.73 16.7361 3 11.9961 3C7.30609 3 2.99609 6.65 2.99609 12.28C2.39609 12.62 1.99609 13.26 1.99609 14V16C1.99609 17.1 2.89609 18 3.99609 18H4.99609V11.9C4.99609 8.03 8.12609 4.9 11.9961 4.9C15.8661 4.9 18.9961 8.03 18.9961 11.9V19H10.9961V21H18.9961C20.0961 21 20.9961 20.1 20.9961 19V17.78C21.5861 17.47 21.9961 16.86 21.9961 16.14V13.84C21.9961 13.14 21.5861 12.53 20.9961 12.22Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 14C9.54838 14 9.99609 13.5523 9.99609 13C9.99609 12.4477 9.54838 12 8.99609 12C8.44381 12 7.99609 12.4477 7.99609 13C7.99609 13.5523 8.44381 14 8.99609 14Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9961 14C15.5484 14 15.9961 13.5523 15.9961 13C15.9961 12.4477 15.5484 12 14.9961 12C14.4438 12 13.9961 12.4477 13.9961 13C13.9961 13.5523 14.4438 14 14.9961 14Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9961 11.03C17.5161 8.18 15.0361 6 12.0461 6C9.01609 6 5.75609 8.51 6.01609 12.45C8.48609 11.44 10.3461 9.24 10.8761 6.56C12.1861 9.19 14.8761 11 17.9961 11.03Z",
    fill: "#4CAF50"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 1.16797C13.7813 1.16797 11.168 3.7813 11.168 7.0013C11.168 10.2213 13.7813 12.8346 17.0013 12.8346C20.2213 12.8346 22.8346 10.2213 22.8346 7.0013C22.8346 3.7813 20.2213 1.16797 17.0013 1.16797ZM15.8346 9.91797L12.918 7.0013L13.7405 6.1788L15.8346 8.26714L20.2621 3.83964L21.0846 4.66797L15.8346 9.91797Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCallSuccess);
export default __webpack_public_path__ + "static/media/live_call_success.1a4cf19a89376d51278e504c032e427e.svg";
export { ForwardRef as ReactComponent };